import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppAuthGuard } from './core/guards/auth.guard';
import { DashboardComponent } from './shared/layouts/dashboard/dashboard.component';
import { WebiatDashboardContentComponent } from './features/webiat-dashboard-content/webiat-dashboard-content.component';
import { WebiatCardCreatorComponent } from './features/webiat-card-creator/webiat-card-creator.component';
import { WebiatAccessDeniedComponent } from './features/webiat-access-denied/webiat-access-denied.component';
import { NonStandardNotificationComponent } from './features/webbiat-notification-creator/non-standard-notification/non-standard-notification.component';
import { AdminGuard } from './core/guards/admin.guard';
import { CommunityManagerGuard } from './core/guards/community-manager.guard';
import { ClubsManagerGuard } from './core/guards/clubs-manager.guard';
import { TrainingManagerGuard } from './core/guards/training-manager.guard';
import { CreditManagerGuard } from './core/guards/credit-manager.guard';
import { AmicalManagerGuard } from './core/guards/amical-manager.guard';
import { EmployeeReimbursementManagerGuard } from './core/guards/employee-reimbursement.guard';
import { NotificationManagerGuard } from './core/guards/notification-manager.guard';
import { CareerManagerGuard } from './core/guards/career-manager.guard';


const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  { path: 'access-denied', component: WebiatAccessDeniedComponent, canActivate: [AppAuthGuard] },
  {
    path: 'expert-rh/form-builder',
    loadComponent: () =>
      import('./shared/components/expert-rh/form-builder/expert-rh-form-builder.component').then(
        m => m.ExpertRhFormBuilderComponent
      ),
    canActivate: [AppAuthGuard, AdminGuard]
  },
  {
    path: 'expert-rh/form-preview',
    loadComponent: () =>
      import('./shared/components/expert-rh/form-preview/expert-rh-form-preview.component').then(
        m => m.ExpertRhFormPreviewComponent
      ),
    canActivate: [AppAuthGuard, AdminGuard]
  },
  {
    path: 'career-interview/form',
    loadChildren: () =>
      import('./shared/components/career-management/career-interview-form/career-interview-form.module').then(
        m => m.CareerInterviewFormModule
      ),
    canActivate: [AppAuthGuard, CareerManagerGuard]
  },
  {
    path: '',
    component: DashboardComponent,
    children: [
      {
        path: 'dashboard',
        component: WebiatDashboardContentComponent,
      },
      {
        path: 'content-managment',
        loadChildren: () =>
          import('./shared/components/content-managment/content-managment.module').then(
            (m) => m.ContentManagmentModule
          ),
        canActivate:[CommunityManagerGuard]
      },
      {
        path: 'content-managment/news-card',
        component: WebiatCardCreatorComponent,
        canActivate:[CommunityManagerGuard]
      },
      {
        path:  'content-managment/edit-card/:id',
        component: WebiatCardCreatorComponent,
        canActivate:[CommunityManagerGuard]
      },
      {
        path: 'collaborator-list',
        loadChildren: () =>
          import('./shared/components/collaborator/collaborator.module').then(
            (m) => m.CollaboratorModule
          ),
        canActivate:[AdminGuard]
      },
      {
        path: 'comments',
        loadChildren: ()=>
          import('./shared/components/comments/comments.module').then(
            (m) => m.CommentsModule
          ),
          canActivate:[CommunityManagerGuard]
      },
      {
        path: 'user-profil',
        loadChildren: () =>
          import('./shared/components/user-profil/user-profil.module').then(
            (m) => m.UserProfilModule
          ),
        canActivate:[AdminGuard]
      },

      {
        path: 'non-standardized-notification-creator',
        component: NonStandardNotificationComponent,
        canActivate:[AdminGuard]
      },
      {
        path: 'clubs-overview',
        loadChildren: () =>
          import('./shared/components/club-management/club-management.module').then(
            (m) => m.ClubManagementRoutingModule
          ),
          canActivate:[ClubsManagerGuard]  
      },    
      {
        path: 'credit-management',
        loadChildren: ()=>
          import('./shared/components/credit-management/credit-management.module').then(
            (m) => m.CreditManagementModule
          ),
          canActivate:[CreditManagerGuard]
      },
      {
        path: 'amical-management',
        loadChildren: () =>
          import('./shared/components/amical-management/amical-management.module').then(
            (m) => m.AmicalManagementModule
          ),
          canActivate:[AmicalManagerGuard]  

      },
      {
        path: 'parametrage',
        loadChildren: () =>
          import('./shared/components/parametrage/parametrage.module').then(
            (m) => m.ParametrageModule  
          ),
        // Using AdminGuard for now as a default
        canActivate:[AdminGuard]
      },
      {
        path: 'employee-reimbursement-management',
        loadChildren: () =>
          import('./shared/components/employee-reimbursement-management/employee-reimbursement-management.module').then(
            (m) => m.EmployeeReimbursementManagementModule
          ),
          canActivate:[EmployeeReimbursementManagerGuard]  

      },
      {
        path: 'notification-management',
        loadChildren: () =>
          import('./shared/components/notification-management/notification-management.module').then(
            (m) => m.NotificationManagementModule
          ),
          canActivate:[NotificationManagerGuard]  
      },
      {
        path: 'career-management',
        loadChildren: () =>
          import('./shared/components/career-management/career-management.module').then(
            (m) => m.CareerManagementModule
          ),
        canActivate: [CareerManagerGuard]
      }     
/*       {
        path: 'training-managment',
        loadChildren: ()=>
          import('./shared/components/training-managment/training-managment.module').then(
            (m) => m.TrainingManagmentModule
          ),
          canActivate:[TrainingManagerGuard]
      } */
    ],
    canActivate: [AppAuthGuard],
    data: { roles: ['ROLE_ADMIN','ROLE_CM','ROLE_CLM','ROLE_TM','ROLE_CO','ROLE_CR','ROLE_CD','ROLE_AM','ROLE_ERM','ROLE_GN'] }
  },
  { path: '**', redirectTo: 'dashboard', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
